import { TabType } from '@carboncopyco/types/desktop';
import { useState } from 'react';
import { useTabManager } from '../services/TabManager';
import { useFocusAppService } from './useFocusAppService';

const useMoreTabsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { triggerFocus } = useFocusAppService();
  const { getActiveGlobalTab } = useTabManager();
  const activeGlobalTab = getActiveGlobalTab();

  const handleIsOpen = (isOpenMenu: boolean) => {
    setIsOpen(isOpenMenu);
    if (
      activeGlobalTab?.type === TabType.BROWSER_WINDOW &&
      activeGlobalTab?.isBrowserUrlValid === false
    )
      return;
    triggerFocus(isOpenMenu);
  };

  return {
    isOpen,
    handleIsOpen,
  };
};

export default useMoreTabsDropdown;
